import type React from 'react';

import { SrOnly } from '../SrOnly';
import { type IconButtonSizeProps, Wrapper } from './wrapper';

type IconButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  title: string;
  children: React.ReactNode;
  size?: IconButtonSizeProps;
  onClick: () => void;
};

const IconButton = ({ title, children, size, onClick, ...props }: IconButtonProps) => (
  <Wrapper title={title} onClick={onClick} data-title={title} $size={size} {...props}>
    {children}
    <SrOnly>{title}</SrOnly>
  </Wrapper>
);

export default IconButton;
